export const capitalizeFirstChar = (string: string) => {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const toMoneyFormat = (string: any) => {
  if (string) return `$${Number(string).toFixed(2)}`
}

export const capitalizeFirstLetter = (str: string) => {
  return str[0].toUpperCase() + str.slice(1)
}

export const convertToSlug = (text: string) => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-')
}

export const truncateWithEllipsis = (text: string, maxLength: number) => {
  if (typeof text !== 'string') return ''
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength - 3) + '...'
}
